export const osnTop103SIcon = {
  data: `<svg viewBox="0 0 280 213" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5"
d="M35.6 176.4C49.32 193.2 74.8 206.36 109.24 206.36C154.04 206.36 182.88 183.68 182.88 151.48C182.88 123.48 158.24
108.64 139.2 106.68C159.92 103.04 180.08 87.6399 180.08 64.1199C180.08 33.0399 153.2 13.4399 109.52 13.4399C76.76
13.4399 53.24 26.0399 38.12 43.1199L57.72 67.76C70.88 55.16 87.12 48.1599 105.32 48.1599C124.92 48.1599 140.04 55.7199
 140.04 70.5599C140.04 84.56 126.32 91.2799 105.6 91.2799C98.32 91.2799 85.72 91.28 82.36 91V125.72C85.16 125.44 97.76
 125.44 105.6 125.44C131.64 125.44 143.12 132.44 143.12 147.56C143.12 161.84 130.52 171.64 107.84 171.64C89.64 171.64
 69.2 163.8 56.32 150.36L35.6 176.4Z" fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-3-s',
};
